import { _ as t } from "../internals/export.js";
var a = Math.hypot,
  r = Math.abs,
  o = Math.sqrt;
t({
  target: "Math",
  stat: !0,
  arity: 2,
  forced: !!a && a(1 / 0, NaN) !== 1 / 0
}, {
  hypot: function hypot(t, a) {
    for (var h, e, n = 0, s = 0, f = arguments.length, i = 0; s < f;) h = r(arguments[s++]), i < h ? (n = n * (e = i / h) * e + 1, i = h) : h > 0 ? n += (e = h / i) * e : n += h;
    return i === 1 / 0 ? 1 / 0 : i * o(n);
  }
});